
import React from 'react';
import OptimizedFinanceProcurementList from './OptimizedFinanceProcurementList';

const FinanceApprovalsApproved = () => {
  return <OptimizedFinanceProcurementList status="approved" />;
};

export default FinanceApprovalsApproved;
